export default "__VITE_ASSET__CPdHO1TI__"